import { PartialBrief } from '../../../../Types/Brief'

interface CreateAccountUserDetails {
  // neither exported from nor correct in GlobalAuthHook (country param is missing entirely)
  email: string
  firstName: string
  lastName: string
  country?: string
  contactNumber: string
  requestsExtraMarketingContent: boolean
}

const getUserDetails = (brief: PartialBrief): CreateAccountUserDetails => {
  const {
    email,
    firstName,
    lastName,
    mobileNumber: contactNumber,
    country,
    requestsExtraMarketingContent,
  } = brief.guest ?? {}

  if (
    email === undefined ||
    firstName === undefined ||
    lastName === undefined ||
    contactNumber == undefined
  )
    throw new Error('Brief guest missing required attributes for registration')

  return {
    email,
    firstName,
    lastName,
    contactNumber,
    country: country ?? undefined,
    requestsExtraMarketingContent: requestsExtraMarketingContent ?? false,
  }
}

export default getUserDetails
